<template>
  <div class="main-promo">
    <div class="main-promo__content">
      <h1 class="main-promo__content_title">
        Платформа для&nbsp;общения,<br />
        работы и&nbsp;обучения онлайн
      </h1>
      <MainPromoSlider class="main-promo__content_achievements" />
    </div>
    <div class="main-promo__controls">
      <slot name="controls"></slot>
    </div>
  </div>
</template>
<script>
import MainPromoSlider from '~/components/Desktop/Main/MainPromoSlider/MainPromoSlider'
export default {
  name: 'MainPromoBlockDesktop',
  components: {
    MainPromoSlider,
  },
}
</script>
<style lang="scss" scoped>
.main-promo {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding-left: 32px;
  padding-right: 32px;

  &__content {
    display: flex;
    &_title {
      font-weight: 500;
      font-size: 56px;
      line-height: 60px;
      @include screen-down('lg') {
        font-size: 36px;
        line-height: 36px;
      }
    }
    &_achievements {
      position: relative;
      height: fit-content;
      margin-right: 0;
      margin-left: auto;
      max-width: 212px;
      overflow: visible;
      padding-bottom: 14px;
    }
  }
  &__controls {
    display: flex;
    column-gap: 24px;
    margin: auto 0 0;
    &_btn {
      justify-content: center;
      :deep & {
        width: fit-content;
      }
      @include screen-down('lg') {
        flex: 1;
        :deep & {
          width: 100%;
          max-width: 50%;
        }
      }
    }
  }
}
</style>
